import axios from "axios";
import i18n from "../../i18n";

const actions = {
  getSingleExaminationAssignment(context, value) {
    return axios
      .get("examinationAssignment/" + value)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  createExaminationAssignment(context, value) {
    return axios
      .post("examinationAssignment", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("examination.assignmentCreatedMessage"),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateExaminationAssignment(context, value) {
    return axios
      .put("examinationAssignment/" + value._id, value)
      .then(function (r) {
        context.commit("CREATE_SNACKBAR", i18n.t("examination.assignmentUpdatedMessage"));
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getExaminationAssignmentOverview(context, id) {
    return axios.get(`/examinationAssignment/${id}/overview`);
  },

  markExaminationEmployeeDone(context, { assignmentId, employeeId }) {
    return axios
      .put(`examinationAssignment/employee/${assignmentId}/${employeeId}/complete`, { status: "SUCCESS" })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },
};

export default actions;
